import './http'
const Login=(data)=>{
    return post('/open/login',data)
}
export default{
    Login
}


// WEBPACK FOOTER //
// ./src/request/api.js